/* Instruments */

import { ReduxState } from '~/store';

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectForm = (state: ReduxState) => state.estimateForm.formData;
export const selectIsSubmitLoading = (state: ReduxState) => state.estimateForm.isSubmitLoading;
export const selectIsDownloadLoading = (state: ReduxState) => state.estimateForm.isDownloadLoading;
export const selectEstimateId = (state: ReduxState) => state.estimateForm.estimateId;
